import { render, staticRenderFns } from "./TaskResultsRefare.vue?vue&type=template&id=4870057a&"
import script from "./TaskResultsRefare.vue?vue&type=script&lang=js&"
export * from "./TaskResultsRefare.vue?vue&type=script&lang=js&"
import style0 from "./TaskResultsRefare.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports